import moment from "moment";
import { mathFix } from "../services/mathServices";
import {
    AutoVatAccountingLine,
    AutoVatDocDetail,
    DeclarationProofData,
    BundleProofData,
} from "../types/taxformTypes";

export function convertCerfaNumber(fullCerfaNumber: string): string {
    if (!fullCerfaNumber) {
        debugger;
        console.error("convertCerfaNumber fullCerfaNumber is undefined");
        return fullCerfaNumber;
    }
    // SPECIFIC
    // must cover old and new versions of declarations (old = bobbee files, new = mtae files)
    const prefixMap: Record<string, string> = {
        "1330CVA": "1330CVAE",
        "3310CA3": "3310CA3",
        "3519": "3519",
        "3517SC": "3517SCA12",
        "3517DDR": "3517DDR",
        "3514": "3514",
        "2571": "2571",
        "2572": "2572",
        "2573": "2573",
        "1329AC": "1329AC",
        "1329DEF": "1329DEF",
        "2777": "2777",
        DAS2: "DAS2",
        "2561": "2561",
        "3517BCA": "3517BCA12",
        "3525BIS": "3525BIS",
    };
    for (const prefix in prefixMap) {
        if (fullCerfaNumber.startsWith(prefix)) {
            return prefixMap[prefix];
        }
    }
    return fullCerfaNumber;
}

export function getDeclarationProof(data: DeclarationProofData): string {
    const shortSiret: string = data?.companySiret?.split("_tcpOf")[0] || "";
    let declaration = `<!DOCTYPE html>
        <html lang="en">
            <head>
                <meta charset="UTF-8" />
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
                <link
                    href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
                    rel="stylesheet"
                />
                <title>${data.declarationTitle}</title>
                <style>
                    table {
                        width: 100vw;
                        border-collapse: collapse;
                        font-family: poppins, Arial, sans-serif;
                    }
                    table * {
                        border-collapse: collapse;
                        border: 1px solid #ddd;
                    }
                    .table-wrapper {
                        overflow: hidden;
                        border-spacing: 0;
                        border-radius: 10px;
                        border: 1px solid #ddd;
                    }
                    th,
                    td {
                        padding: 4px 18px;
                        font-size: small;
                        font-family: poppins, Arial, sans-serif;
                        text-align: left;
                        text-wrap: wrap;
                        border-collapse: collapse;
                    }
                    h1 {
                        text-align: center;
                        font-size:  x-large;
                        font-family: poppins, Arial, sans-serif;
                        color: white;
                        padding: 2px;
                        background-color: #f9b128;
                        border-radius: 8px;
                    }
                    h2 {
                        color: white;
                        padding: 2px;
                        font-family: poppins,Arial, sans-serif;
                        background-color: #f9b128;
                        font-size: large;
                        padding: 4px 18px;
                        border-radius: 8px;
                    }
                    th {
                        background-color: #f2f2f2;
                        width: 150px;
                    }
                    .accepted {
                        color: #21bf27;
                    }
                    .container {
                        margin-top: 20px;
                    }
                    .edi-title {
                        font-size: 14px;
                        color: black;
                        padding: 4px 18px;
                        font-family: poppins, Arial, sans-serif;
                    }
                    .company-name, .company-siret {
                        color: #f9b128;
                    }
                    .verification-note {
                        font-size: 14px;
                        color: black;
                        padding: 4px 18px;
                        font-family: poppins, Arial, sans-serif;
                    }
                </style>
            </head>
            <body>
            `;
    if (data.isSiretSlip) {
        declaration += `
                <h1>Compte rendu EDI pour le SIRET : ${shortSiret}</h1>
            `;
    } else if (data.isMailDetails && data.isAccountingFirmOfCompany) {
        declaration += `
            <p>Bonjour,</p></br></br>
            <p>Une déclaration vient d'être envoyé à la DGFIP via bobbee par ${data.accountingFirmName}, vous trouverez ci-dessous les informations relatives à cet envoi.</p>

        `;
    } else if (data.isMailDetails) {
        declaration += `
            <p>Bonjour,</p></br></br>
            <p>Une déclaration vient d'être envoyé à la DGFIP via bobbee, vous trouverez ci-dessous les informations relatives à cet envoi.</p>

        `;
    }
    declaration += `    <h2 scope="row">DOSSIER</h2>
                <div class="table-wrapper">
                    <table>
                        <tr>
                            <th scope="row">Nom de l'entreprise :</th>
                            <td> ${data.companyName}</td>
                        </tr>
                        <tr>
                            <th scope="row">Nom du document :</th>
                            <td> ${data.formName} de ${data.formYear}</td>
                        </tr>
                    </table>
                </div>
                <h2 scope="row"> PÉRIODE & INFORMATIONS DÉCLARÉES</h2>
                <div class="table-wrapper">
                    <table>
                        <tr>
                            <th scope="row">Période déclarée :</th>
                            <td> ${data.periodDocument}</td>
                        </tr>
                        <tr>
                            <th scope="row">Montant déclaré :</th>
                            <td> ${data.amountDeclared || 0} €</td>
                        </tr>
                        <tr>
                                <th scope="row">Montant payé :</th>
                                <td> ${data.amountPaid} €</td>
                        </tr>`;
    if (data.isPaymentsRows && data.payment?.length) {
        data.payment.forEach((element) => {
            declaration += `
            <tr>
                <td>dont ${element.amount} €</td>
                <td>IBAN : ${element.IBAN} / BIC : ${element.BIC}</td>
            </tr>
            `;
        });
    }
    declaration += `<tr>
                            <th scope="row">CERFA transmis :</th>
                            <td>${data.cerfaNumber}</td>
                        </tr>
    `;
    if (data.isMTAEID) {
        declaration += `
                        <tr>
                            <th scope="row">Numéro EDI :</th>
                            <td>${data.mtaeId}</td>
                        </tr>
                        `;
    }
    declaration += `
                        <tr>
                            <th scope="row">Date d'envoi :</th>
                            <td>${data.dateSend} heure française</td>
                        </tr> `;
    if (
        data.isDeclarationStatus &&
        data.processingDate &&
        data.declarationStatus &&
        data.statusValidationDate
    ) {
        declaration += `
                        <tr>
                            <th scope="row">Date de traitement par la DGFiP :</th>
                            <td>${data.processingDate}</td>
                        </tr>
                        <tr>
                            <th scope="row">Statut EDI :</th>
                            <td>${data.declarationStatus}</td>
                        </tr>
                        <tr>
                            <th scope="row">Date de confirmation du statut :</th>
                            <td>${data.statusValidationDate}</td>
                        </tr>`;
    }
    declaration += `
                    </table>
                </div>
                <br />`;
    if (data.isMailDetails) {
        declaration += `<b class="edi-title">
                    Vous pouvez dès à présent retrouver dans bobbee la déclaration dans le menu Documents.
                </b>
                <br />
                <img style="height: 150px;" src="cid:signature@bobbeeAgiris" />
            </body>
        </html>
                `;
    } else {
        declaration += `
                <b class="edi-title">
                    Vous utilisez un système EDI pour justifier l'envoi de votre déclaration, dont le numéro SIRET est :
                    <span class="company-siret">${shortSiret}
                    </span>
                </b>
                <br />
                <b class="verification-note">
                    Veuillez également vérifier le statut de cette déclaration sur le site de la DGFIP pendant que vous consultez ce justificatif
                </b>
            </body>
        </html>`;
    }
    return declaration;
}

export function getBundleProof(data: BundleProofData) {
    const shortSiret: string = data?.companySiret?.split("_tcpOf")[0] || "";
    let bundle: string = `<!DOCTYPE html>
        <html lang="en">
            <head>
                <meta charset="UTF-8" />
                <link rel="preconnect" href="https://fonts.googleapis.com" />

                <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
                <link
                    hrefx="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
                    rel="stylesheet"
                />
                <title>Compte rendu EDI</title>
                <style>
                    table {π
                        width: 100vw;
                        border-collapse: collapse;
                        font-family: poppins;
                        text-wrap: wrap;
                    }
                    table * {
                        border-collapse: collapse;
                        border: 1px solid #ddd;
                    }
                    .table-wrapper {
                        overflow: hidden;
                        border-spacing: 0;
                        border-radius: 10px;
                        border: 1px solid #ddd;
                    }
                    th,
                    td {
                        padding: 4px 18px;
                        font-size: small;
                        font-family: poppins;
                        text-align: left;
                        width: 100vh;
                        text-wrap: wrap;
                        border-collapse: collapse;
                    }
                    h1 {
                        text-align: center;
                        font-size:  x-large;
                        font-family: poppins;
                        color: white;
                        padding: 2px;
                        background-color: #f9b128;
                        border-radius: 8px;
                    }
                    h2 {
                        color: white;
                        padding: 2px;
                        font-family: poppins;
                        background-color: #f9b128;
                        font-size: large;
                        padding: 4px 18px;
                        border-radius: 8px;
                    }
                    th {
                        background-color: #f2f2f2;
                    }
                    .accepted {
                        color: #21bf27;
                    }
                    .container {
                        margin-top: 20px;
                    }
                    .edi-title {
                        font-size: 14px;
                        color: black;
                        padding: 4px 18px;
                        font-family: poppins;
                    }
                    .company-name, .company-siret {
                        color: #f9b128;
                    }
                    .verification-note {
                        font-size: 14px;
                        color: black;
                        padding: 4px 18px;
                        font-family: poppins;
                    }
                </style>
            </head>
            <body>
                <h2 scope="row">DOSSIER</h2>
                <div class="table-wrapper">
                    <table>
                        <tr>
                            <th scope="row">Nom de l'entreprise :</th>
                            <td> ${data.companyName}</td>
                        </tr>
                        <th scope="row">Régime :</th>
                            <td> ${data.incomeCategory}</td>
                        </tr>
                    </table>
                </div>
                <h2 scope="row">PÉRIODE & INFORMATIONS DÉCLARÉES</h2>
                <div class="table-wrapper">
                    <table>
                        <tr>
                            <th scope="row"> Date d'ouverture de l'exercice :</th>
                            <td> ${data.accountingStart}</td>
                        </tr>

                        <tr>
                            <th scope="row">Date de clôture de l'exercice :</th>
                            <td>${data.accountingEnd}</td>
                        </tr>
                        <tr>
                            <th scope="row">CERFA transmis :</th>
                            <td>${data.cerfaNumber}</td>
                        </tr>

                        <tr>
                            <th scope="row">Numéro EDI :</th>
                            <td>${data.mtaeId}</td>
                        </tr>

                        <tr>
                            <th scope="row">Date d'envoi :</th>
                            <td>${data.dateSend} heure française</td>
                        </tr>

                        <tr>
                            <th scope="row">Date de traitement par la DGFiP :</th>
                            <td>${data.processingDate}</td>
                        </tr>

                        <tr>
                            <th scope="row">Statut EDI :</th>
                            <td>${data.declarationStatus}</td>
                        </tr>

                        <tr>
                            <th scope="row">Date de confirmation du statut :</th>
                            <td>${data.statutValidationDate}</td>
                        </tr>
                    </table>
                </div>
                <b class="edi-title">Vous utilisez un système EDI pour justifier l'envoi de votre déclaration liée à la société <span class="company-name">${data.companyName}</span> dont le numéro SIRET est : <span class="company-siret">${shortSiret}</span> </b>
                <b class="verification-note">Veuillez également vérifier le statut de cette déclaration sur le site de la DGFIP pendant que vous consultez ce justificatif</b>
            </body>
        </html>`;
    return bundle;
}

export function extractNumberBtqStreet(address: string): {
    number: string;
    btq: string;
    street: string;
} {
    const numbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    const btqList = ["bis", "ter", "quater", "quinquies", "sexies", "septies", "octies", "nonies"];
    let number = "";
    let btq = "";
    let street = "";
    if (address?.length) {
        street = address;
        const elements = address.split(" ");
        if (elements[0]?.length) {
            const chars = elements[0].split("");
            if (chars.every((char) => numbers.includes(char))) {
                number = elements[0];
                if (elements[1]?.length && btqList.includes(elements[1].toLowerCase())) {
                    btq = elements[1];
                    street = address.substring(elements[0].length + elements[1].length + 2);
                } else {
                    street = address.substring(elements[0].length + 1);
                }
            }
        }
    }
    return { number, btq, street };
}

export class VatItemAuto {
    docId: string;
    name: string;
    date: string;
    totalGrossAmountSigned: number;
    totalVatToDeclare: number;
    totalNetToDeclare: number;
    toAdd: boolean;
    details: AutoVatDocDetail[];
    grossAmountAls: AutoVatAccountingLine[];
    vatScheme: string;
    accountingLines: Array<any>;
    totalOutputVat: number;
    originalType: string;
    type: "autoValidItems" | "purchasesOnReceiptsNotReconciliated";
    gotAnomalies: boolean;
    isExpanded: boolean;
    isAlreadyDeclared: boolean;

    constructor(
        docId: string,
        name: string,
        date: string,
        totalGrossAmountSigned: number,
        totalVatToDeclare: number,
        totalNetToDeclare: number,
        toAdd: boolean,
        details: AutoVatDocDetail[],
        grossAmountAls: AutoVatAccountingLine[],
        vatScheme: string,
        accountingLines: Array<any>,
        totalOutputVat: number,
        originalType: string,
        type: "autoValidItems" | "purchasesOnReceiptsNotReconciliated",
        gotAnomalies: boolean,
        isExpanded: boolean,
        isAlreadyDeclared: boolean
    ) {
        this.docId = docId || "";
        this.name = name || "";
        this.date = date || "";
        this.totalGrossAmountSigned = totalGrossAmountSigned || 0;
        this.totalVatToDeclare = totalVatToDeclare || 0;
        this.totalNetToDeclare = totalNetToDeclare || 0;
        this.toAdd = toAdd || false;
        this.details = details || null;
        this.grossAmountAls = grossAmountAls || null;
        this.vatScheme = vatScheme || "";
        this.accountingLines = accountingLines || [];
        this.totalOutputVat = totalOutputVat || 0;
        this.originalType = originalType || "";
        this.type = type || "autoValidItems";
        this.gotAnomalies = gotAnomalies || false;
        this.isExpanded = isExpanded || false;
        this.isAlreadyDeclared = isAlreadyDeclared || false;
    }

    toggleExpand() {
        this.isExpanded = !this.isExpanded;
    }

    get documentDate() {
        return moment(this.date).format("DD/MM/YYYY");
    }
}

export class VatItemAssist {
    bankTransactionId: string;
    dateDebit: string;
    wording: string;
    type: string;
    grossAmount: number;
    vatRate: number;
    netAmount: number;
    vatAmount_: number;
    toAdd: boolean;
    accountingLines: AccountingLineVatAssist[];
    isSubItem: boolean;
    hasBeenSplitted: boolean;
    grossAmountBeforeSplit: number;
    subOrAddedItemId: number;
    isAlreadyDeclared: boolean;

    constructor(
        bankTransactionId: string,
        dateDebit: string,
        wording: string,
        type: string,
        grossAmount: number,
        vatRate: number,
        netAmount: number,
        vatAmount: number,
        toAdd: boolean,
        accountingLines: AccountingLineVatAssist[],
        isSubItem: boolean,
        hasBeenSplitted: boolean,
        grossAmountBeforeSplit: number,
        subOrAddedItemId: number,
        isAlreadyDeclared: boolean
    ) {
        this.bankTransactionId = bankTransactionId || null;
        this.dateDebit = dateDebit || null;
        this.wording = wording || "";
        this.type = type || null;
        this.grossAmount = Math.abs(grossAmount) || 0;
        this.vatRate = vatRate || 0;
        this.netAmount = netAmount || 0;
        this.vatAmount_ = vatAmount || 0;
        this.toAdd = toAdd || false;
        this.accountingLines = accountingLines || [];
        this.isSubItem = isSubItem || false;
        this.hasBeenSplitted = hasBeenSplitted || false;
        this.grossAmountBeforeSplit = grossAmountBeforeSplit || null;
        this.subOrAddedItemId = subOrAddedItemId || null;
        this.isAlreadyDeclared = isAlreadyDeclared || false;
    }

    get displayDate() {
        return moment(this.dateDebit).format("DD/MM/YYYY");
    }

    get displayGrossAmount() {
        let netAmount: number = 0;
        let vatAmount: number = 0;
        if (this.hasBeenSplitted) {
            netAmount = 0;
            vatAmount = 0;
            if (this.netAmount !== netAmount) {
                this.netAmount = netAmount;
            }
            if (this.vatAmount !== vatAmount) {
                this.vatAmount = vatAmount;
            }
            return Math.abs(this.grossAmountBeforeSplit);
        }
        return Math.abs(this.grossAmount);
    }

    get displayNetAmount() {
        if (this.type === "Import" || this.type === "Intracom" || this.type === "Export") {
            this.netAmount = +this.grossAmount;
            // if (this.hasBeenSplitted) {
            //     return Math.abs(this.grossAmountBeforeSplit);
            // }
        } else if (this.vatRate) {
            this.netAmount = mathFix(this.grossAmount / (1 + this.vatRate / 100), 2);
            // if (this.hasBeenSplitted) {
            //     return Math.abs(mathFix(this.grossAmountBeforeSplit / (1 + this.vatRate / 100), 2));
            // }
        } else if (!this.vatRate && !Number.isNaN(this.vatAmount)) {
            this.netAmount = this.grossAmount - this.vatAmount;
            // if (this.hasBeenSplitted) {
            //     return Math.abs(this.grossAmountBeforeSplit - this.displayVatAmount);
            // }
        }
        return Math.abs(this.netAmount);
    }

    get displayVatAmount() {
        let vatAmount: number = 0;
        if (this.type === "Import" || this.type === "Intracom") {
            vatAmount = (this.grossAmount * this.computedVatRate) / 100;
            if (this.vatAmount !== vatAmount) {
                this.vatAmount = vatAmount;
            }
            // if (this.hasBeenSplitted) {
            //     return Math.abs((this.grossAmountBeforeSplit * this.computedVatRate) / 100);
            // }
        } else if (this.type === "Export") {
            vatAmount = 0;
            if (this.vatAmount !== vatAmount) {
                this.vatAmount = vatAmount;
            }
        } else if (this.vatRate !== null) {
            vatAmount = mathFix(
                (this.grossAmount / (1 + this.vatRate / 100)) * (this.vatRate / 100)
            );
            if (this.vatAmount !== vatAmount) {
                this.vatAmount = vatAmount;
            }
            // if (this.hasBeenSplitted) {
            //     return Math.abs(
            //         mathFix(
            //             (this.grossAmountBeforeSplit / (1 + this.vatRate / 100)) *
            //                 (this.vatRate / 100),
            //         ),
            //     );
            // }
        }
        return Math.abs(this.vatAmount);
    }

    get computedVatRate() {
        if (this.type === "Intracom" || this.type === "Import") {
            this.vatRate = 20;
        }
        if (this.type === "Export" || this.type === "NoVat") {
            this.vatRate = 0;
        }
        if (this.type === "Collectée" && ![0, 2.1, 5.5, 8.5, 10, 20].includes(this.vatRate)) {
            this.vatRate = 20;
        }
        return this.vatRate;
    }

    set computedVatRate(data) {
        this.vatRate = data;
    }

    get vatAmount() {
        return Math.abs(this.vatAmount_);
    }

    set vatAmount(data) {
        this.vatAmount_ = data;
    }

    get toDisplayAccountableAccounts() {
        return this.accountingLines
            .filter((al) => al.aaName && !al.aaName.startsWith("512"))
            .map((al) => al.aaName);
    }

    getAccountableAccountColor(aaName) {
        return aaName?.startsWith("471") ? "red" : "green";
    }

    // get toDisplayThirdPartyCompanies() {
    //     return this.accountingLines
    //         .filter((al) => al.thirdPartyCompanyName)
    //         .map((al) => al.thirdPartyCompanyName);
    // }

    // get toDisplayUsers() {
    //     return this.accountingLines
    //         .filter((al) => al.userDisplayName)
    //         .map((al) => al.userDisplayName);
    // }
    get thirdParties() {
        let users = "";
        let clients = "";
        let suppliers = "";
        for (const al of this.accountingLines) {
            if (al.userDisplayName) {
                if (!users) {
                    users += "Collaborateur : ";
                } else {
                    users += ", ";
                }
                users += al.userDisplayName;
            }
            if (al.thirdPartyCompanyName) {
                if (al.aaName.startsWith("401")) {
                    if (!suppliers) {
                        suppliers += "Fournisseur : ";
                    } else {
                        suppliers += ", ";
                    }
                    suppliers += al.thirdPartyCompanyName;
                } else if (al.aaName.startsWith("411")) {
                    if (!clients) {
                        clients += "Client : ";
                    } else {
                        clients += ", ";
                    }
                    clients += al.thirdPartyCompanyName;
                }
            }
        }
        let thirdParties = users;
        if (clients) {
            thirdParties += clients;
        }
        if (suppliers) {
            thirdParties += suppliers;
        }
        return thirdParties ? " - " + thirdParties : "";
    }
}

export type AccountingLineVatAssist = {
    aaName: string;
    thirdPartyCompanyName: string;
    userDisplayName: string;
};
